import { render, staticRenderFns } from "./PapercleandArticoliEditModalComponent.vue?vue&type=template&id=4ed9f763"
import script from "./PapercleandArticoliEditModalComponent.vue?vue&type=script&lang=js"
export * from "./PapercleandArticoliEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports